import React from "react";
import { makeStyles } from "@mui/styles";
import Box from "@mui/material/Box";
import { Link } from "react-router-dom";
import { HashLink } from "react-router-hash-link";
const useStyles = makeStyles({
  orangeDot: {
    width: "10px",
    height: "10px",
    borderRadius: "3px",
    backgroundColor: "#f3756d",
    marginRight: "20px",
  },
  eachCursor: {
    backgroundColor: "white",
    padding: "20px",

    display: "flex",
    alignItems: "center",
    marginBottom: "5px",
  },
  each: {
    backgroundColor: "white",
    padding: "20px",
    marginRight: "5px",
    marginBottom: "5px",
  },
});

const DashboardMenuEach = ({ menu, link, cursor }) => {
  const classes = useStyles();

  if (cursor) {
    return (
      <Box className={classes.eachCursor}>
        <Box className={classes.orangeDot}></Box>
        <HashLink to={link}>{menu}</HashLink>
      </Box>
    );
  } else {
    return (
      <Box className={classes.each}>
        <HashLink to={link}>{menu}</HashLink>
      </Box>
    );
  }
};

export default DashboardMenuEach;
